import { render, staticRenderFns } from "./selfShipmentForm.vue?vue&type=template&id=3a01765d"
import script from "./selfShipmentForm.vue?vue&type=script&lang=js"
export * from "./selfShipmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports